import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';

import Home from './pages/home';
import Feedback from './pages/feedback';
import AdminLogin from './pages/sign-in';
import AdminDashboard from './pages/dashboard';
import PrivateRoute from './components/private-route';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>

          {/* PUBLIC ROUTES */}
          <Route path="/" element={<Home />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/admin-login" element={<AdminLogin />} />

          {/* PRIVATE ROUTES */}
          <Route
            path="/admin-dashboard"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
